import React from 'react'
import { Typography, Box, Chip, Tooltip } from '@mui/material'
import { ArrowForward } from '@mui/icons-material'
import Flag from '../../mailTemplate/src/components/atomic/atoms/Flag'

const CampaignHeader = ({ campaignDetails }) => {
  if (!campaignDetails) return null

  const productNames = campaignDetails?.productName || []
  const maxVisible = 2

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant='h6'
        sx={{
          fontWeight: 600,
          mb: 1,
          color: 'text.primary',
          textAlign: 'center',
          lineHeight: 1.2
        }}
      >
        {campaignDetails?.name}
      </Typography>

      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 0.5,
        justifyContent: 'center',
        mb: 2
      }}>
        {productNames.slice(0, maxVisible).map((product, index) => (
          <Chip
            key={index}
            label={product}
            size="small"
            sx={{
              borderRadius: 1.5,
              height: 20,
              fontSize: '0.75rem',
              backgroundColor: 'action.hover',
              '& .MuiChip-label': {
                px: 1
              }
            }}
          />
        ))}
        {productNames.length > maxVisible && (
          <Tooltip
            title={productNames.slice(maxVisible).join(', ')}
            arrow
          >
            <Chip
              label={`+${productNames.length - maxVisible}`}
              size="small"
              sx={{
                borderRadius: 1.5,
                height: 20,
                fontSize: '0.75rem',
                backgroundColor: 'action.selected',
                fontWeight: 500,
                '& .MuiChip-label': {
                  px: 1
                }
              }}
            />
          </Tooltip>
        )}
      </Box>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1.5,
        mb: 2
      }}>
        <Flag
          code={campaignDetails?.currentCountryCode}
          square
          style={{
            fontSize: '1.75rem',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        />
        <ArrowForward sx={{
          color: 'primary.main',
          fontSize: '1.25rem'
        }} />
        <Flag
          code={campaignDetails?.importerCountryCodes?.[0]}
          square
          style={{
            fontSize: '1.75rem',
            borderRadius: '6px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
          }}
        />
      </Box>
    </Box>
  )
}

export default CampaignHeader
